import { Popover, TextField, Typography } from "@mui/material"
import { Settings02 } from "@untitled-ui/icons-react"
import React, { useMemo, useState } from "react"

import Button from "./Button"
import { IconButton } from "./IconButton"
import { Stack } from "./Stack"

export const DEFAULT_SLIPPAGE = 0.5

type SettingsPopoverProps = {
  slippage: number
  setSlippage: (slippage: number) => void
}

export function SettingsPopover(props: SettingsPopoverProps) {
  const { slippage, setSlippage } = props

  const [slippageValue, setSlippageValue] = React.useState(String(slippage))

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const closePopover = () => {
    setAnchorEl(null)
    setSlippageValue(String(slippage))
  }

  const hasError = useMemo(() => {
    return String(slippage) !== slippageValue
  }, [slippageValue, slippage])

  return (
    <>
      <Popover
        open={Boolean(anchorEl)}
        onClose={closePopover}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPopover-paper": {
            width: "260px",
            padding: 1.5,
          },
        }}
      >
        <Stack>
          <Typography>Max slippage</Typography>
          <Stack direction="row">
            <Button
              className={slippage === DEFAULT_SLIPPAGE ? "accent" : ""}
              onClick={() => {
                setSlippage(DEFAULT_SLIPPAGE)
                setSlippageValue(String(DEFAULT_SLIPPAGE))
              }}
              data-testid="slippage-auto"
            >
              Auto
            </Button>
            <TextField
              size="small"
              inputProps={{
                sx: {
                  textAlign: "right",
                },
              }}
              InputProps={{
                endAdornment: (
                  <Typography marginLeft={0.5} color="text.secondary">
                    %
                  </Typography>
                ),
              }}
              color={hasError ? "error" : "secondary"}
              type="number"
              value={slippageValue}
              onChange={(e) => {
                setSlippageValue(e.target.value)

                const newValue = parseFloat(e.target.value)
                if (isNaN(newValue)) return

                const formatted = parseFloat(newValue.toFixed(2))
                // special edge case to allow testing
                if (formatted === -42) setSlippage(formatted)
                if (formatted <= 0 || formatted >= 100) return

                setSlippage(formatted)
              }}
              data-testid="slippage-input"
            />
          </Stack>
        </Stack>
      </Popover>
      <IconButton
        size="medium"
        onClick={(event) => {
          setAnchorEl(event.currentTarget)
        }}
        data-testid="settings-button"
      >
        {" "}
        <Settings02 />
      </IconButton>
    </>
  )
}
